{
	"RandomiseTitle": "Randomise Password",
	"PasswordRequirements_Title": "Password Requirements:",
	"PasswordStrength_0": "Too short",
	"PasswordStrength_1": "Very weak",
	"PasswordStrength_2": "Weak",
	"PasswordStrength_3": "Moderate",
	"PasswordStrength_4": "Strong",
	"PasswordStrength_5": "Very Strong",
	"NAME": "PasswordTextInput"
}